import { v4 as uuidv4 } from 'uuid'

const USER_ID_KEY = 'xinxiaoshi_user_id'

/**
 * 生成用户标识
 * 使用 UUID 确保唯一性，localStorage 持久化存储
 */
export const getUserId = (): string => {
  let userId = localStorage.getItem(USER_ID_KEY)

  if (!userId) {
    userId = `user_${uuidv4()}`
    localStorage.setItem(USER_ID_KEY, userId)
  }

  return userId
}